module.exports = __webpack_public_path__ + "static/media/城市配送_13.24266851.jpg";